import { defineMessages } from "react-intl";
export const propertyMessage = defineMessages({
    Share: {
        id: "template-form.property.propertyType.share",
        defaultMessage: "Share"
    },
    Cadastre: {
        id: "template-form.property.propertyType.cadastre",
        defaultMessage: "Cadastre"
    },
    Stock: {
        id: "template-form.property.propertyType.stock",
        defaultMessage: "Stock"
    },
    Project: {
        id: "template-form.property.propertyType.project",
        defaultMessage: "Project"
    },
    Unknown: {
        id: "template-form.property.propertyType.unknown",
        defaultMessage: "Unknown"
    }
});
//# sourceMappingURL=ApplicationProperty.js.map